module.exports = __webpack_public_path__ + "static/media/10-hibah.319f2c9c.png";